export const books = [
  {
    id: '02-GEN',
    name: 'Genesis',
    chapters: 50,
  },
  {
    id: '03-EXO',
    name: 'Exodus',
    chapters: 40,
  },
  {
    id: '04-LEV',
    name: 'Leviticus',
    chapters: 27,
  },
  {
    id: '05-NUM',
    name: 'Numbers',
    chapters: 36,
  },
  {
    id: '06-DEU',
    name: 'Deuteronomy',
    chapters: 34,
  },
  {
    id: '07-JOS',
    name: 'Joshua',
    chapters: 24,
  },
  {
    id: '08-JDG',
    name: 'Judges',
    chapters: 21,
  },
  {
    id: '09-RUT',
    name: 'Ruth',
    chapters: 4,
  },
  {
    id: '10-1SA',
    name: '1 Samuel',
    chapters: 31,
  },
  {
    id: '11-2SA',
    name: '2 Samuel',
    chapters: 24,
  },
  {
    id: '12-1KI',
    name: '1 Kings',
    chapters: 22,
  },
  {
    id: '13-2KI',
    name: '2 Kings',
    chapters: 25,
  },
  {
    id: '14-1CH',
    name: '1 Chronicles',
    chapters: 29,
  },
  {
    id: '15-2CH',
    name: '2 Chronicles',
    chapters: 36,
  },
  {
    id: '16-EZR',
    name: 'Ezra',
    chapters: 10,
  },
  {
    id: '17-NEH',
    name: 'Nehemiah',
    chapters: 13,
  },
  {
    id: '18-EST',
    name: 'Esther',
    chapters: 10,
  },
  {
    id: '19-JOB',
    name: 'Job',
    chapters: 42,
  },
  {
    id: '20-PSA',
    name: 'Psalms',
    chapters: 150,
  },
  {
    id: '21-PRO',
    name: 'Proverbs',
    chapters: 31,
  },
  {
    id: '22-ECC',
    name: 'Ecclesiastes',
    chapters: 12,
  },
  {
    id: '23-SNG',
    name: 'Song of Solomon',
    chapters: 8,
  },
  {
    id: '24-ISA',
    name: 'Isaiah',
    chapters: 66,
  },
  {
    id: '25-JER',
    name: 'Jeremiah',
    chapters: 52,
  },
  {
    id: '26-LAM',
    name: 'Lamentations',
    chapters: 5,
  },
  {
    id: '27-EZK',
    name: 'Ezekiel',
    chapters: 48,
  },
  {
    id: '28-DAN',
    name: 'Daniel',
    chapters: 12,
  },
  {
    id: '29-HOS',
    name: 'Hosea',
    chapters: 14,
  },
  {
    id: '30-JOL',
    name: 'Joel',
    chapters: 3,
  },
  {
    id: '31-AMO',
    name: 'Amos',
    chapters: 9,
  },
  {
    id: '32-OBA',
    name: 'Obadiah',
    chapters: 1,
  },
  {
    id: '33-JON',
    name: 'Jonah',
    chapters: 4,
  },
  {
    id: '34-MIC',
    name: 'Micah',
    chapters: 7,
  },
  {
    id: '35-NAM',
    name: 'Nahum',
    chapters: 3,
  },
  {
    id: '36-HAB',
    name: 'Habakkuk',
    chapters: 3,
  },
  {
    id: '37-ZEP',
    name: 'Zephaniah',
    chapters: 3,
  },
  {
    id: '38-HAG',
    name: 'Haggai',
    chapters: 2,
  },
  {
    id: '39-ZEC',
    name: 'Zechariah',
    chapters: 14,
  },
  {
    id: '40-MAL',
    name: 'Malachi',
    chapters: 4,
  },
  {
    id: '41-TOB',
    name: 'Tobit',
    chapters: 14,
  },
  {
    id: '42-JDT',
    name: 'Judith',
    chapters: 16,
  },
  {
    id: '43-ESG',
    name: 'Esther (Greek)',
    chapters: 16,
  },
  {
    id: '45-WIS',
    name: 'Wisdom of Solomon',
    chapters: 19,
  },
  {
    id: '46-SIR',
    name: 'Sirach',
    chapters: 51,
  },
  {
    id: '47-BAR',
    name: 'Baruch',
    chapters: 6,
  },
  {
    id: '52-1MA',
    name: '1 Maccabees',
    chapters: 16,
  },
  {
    id: '53-2MA',
    name: '2 Maccabees',
    chapters: 15,
  },
  {
    id: '54-1ES',
    name: '1 Esdras',
    chapters: 9,
  },
  {
    id: '55-MAN',
    name: 'Prayer of Manasseh',
    chapters: 1,
  },
  {
    id: '56-PS2',
    name: 'Psalm 151',
    chapters: 1,
  },
  {
    id: '57-3MA',
    name: '3 Maccabees',
    chapters: 7,
  },
  {
    id: '58-2ES',
    name: '2 Esdras',
    chapters: 16,
  },
  {
    id: '59-4MA',
    name: '4 Maccabees',
    chapters: 18,
  },
  {
    id: '60-DAG',
    name: 'Daniel (Greek)',
    chapters: 14,
  },
  {
    id: '70-MAT',
    name: 'Matthew',
    chapters: 28,
  },
  {
    id: '71-MRK',
    name: 'Mark',
    chapters: 16,
  },
  {
    id: '72-LUK',
    name: 'Luke',
    chapters: 24,
  },
  {
    id: '73-JHN',
    name: 'John',
    chapters: 21,
  },
  {
    id: '74-ACT',
    name: 'Acts',
    chapters: 28,
  },
  {
    id: '75-ROM',
    name: 'Romans',
    chapters: 16,
  },
  {
    id: '76-1CO',
    name: '1 Corinthians',
    chapters: 16,
  },
  {
    id: '77-2CO',
    name: '2 Corinthians',
    chapters: 13,
  },
  {
    id: '78-GAL',
    name: 'Galatians',
    chapters: 6,
  },
  {
    id: '79-EPH',
    name: 'Ephesians',
    chapters: 6,
  },
  {
    id: '80-PHP',
    name: 'Philippians',
    chapters: 4,
  },
  {
    id: '81-COL',
    name: 'Colossians',
    chapters: 4,
  },
  {
    id: '82-1TH',
    name: '1 Thessalonians',
    chapters: 5,
  },
  {
    id: '83-2TH',
    name: '2 Thessalonians',
    chapters: 3,
  },
  {
    id: '84-1TI',
    name: '1 Timothy',
    chapters: 6,
  },
  {
    id: '85-2TI',
    name: '2 Timothy',
    chapters: 4,
  },
  {
    id: '86-TIT',
    name: 'Titus',
    chapters: 3,
  },
  {
    id: '87-PHM',
    name: 'Philemon',
    chapters: 1,
  },
  {
    id: '88-HEB',
    name: 'Hebrews',
    chapters: 11,
  },
  {
    id: '89-JAS',
    name: 'James',
    chapters: 5,
  },
  {
    id: '90-1PE',
    name: '1 Peter',
    chapters: 5,
  },
  {
    id: '91-2PE',
    name: '2 Peter',
    chapters: 2,
  },
  {
    id: '92-1JN',
    name: '1 John',
    chapters: 5,
  },
  {
    id: '93-2JN',
    name: '2 John',
    chapters: 1,
  },
  {
    id: '94-3JN',
    name: '3 John',
    chapters: 1,
  },
  {
    id: '95-JUD',
    name: 'Jude',
    chapters: 1,
  },
  {
    id: '96-REV',
    name: 'Revelation',
    chapters: 21,
  },
];
